
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Wrench, Search, Database } from 'lucide-react';
import BrokenGamesDetector from './BrokenGamesDetector';
import AdminGamesDuplicates from './AdminGamesDuplicates';

const AdminGamesTools = () => {
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Wrench className="w-5 h-5" />
          Games Management Tools
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="broken-games" className="w-full">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="broken-games" className="flex items-center gap-2">
              <Search className="w-4 h-4" />
              Broken Games
            </TabsTrigger>
            <TabsTrigger value="duplicates" className="flex items-center gap-2">
              <Database className="w-4 h-4" />
              Duplicates
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="broken-games" className="mt-6">
            <BrokenGamesDetector />
          </TabsContent>
          
          <TabsContent value="duplicates" className="mt-6">
            <AdminGamesDuplicates />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default AdminGamesTools;
